export enum Currency {
	CHF = "CHF",
	EUR = "EUR",
	USD = "USD"
}

export const Currencies = [Currency.CHF, Currency.EUR, Currency.USD];
